import { expandUserView, UserValue } from 'lib/actions/user'
import { UserRef, UserServiceGetUsersByIDsRequest, UserServiceGetUsersByIDsResponse, UserView } from 'pbts/c1/api/user/v1/user'
import { UserSearchClient, UserServiceClient } from 'pbts/c1/api/user/v1/user.client'
import { Any } from 'pbts/google/protobuf/any'
import { createMutationApi } from 'redux_toolkit/lib/createMutationApi'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'
import { createMultiGetApi, MultiGetOpts } from './lib/createMultiGetApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const transformUserValueArrayResponse = (resp: { list: UserView[], expanded: Any[] }): Array<UserValue> => {
    return resp.list.map((v): UserValue => expandUserView(v, resp.expanded))
}

export const userSearchApi = createPagedListApi(
    UserSearchClient,
    'search',
    transformUserValueArrayResponse,
    UserRef.typeName,
)

export const managedUserSearchApi = createPagedListApi(
    UserSearchClient,
    'searchManagedUsers',
    transformUserValueArrayResponse,
    UserRef.typeName,
)

export const managedUserSearchForAccessRequestsApi = createPagedListApi(
    UserSearchClient,
    'searchManagedUsersForAccessRequests',
    transformUserValueArrayResponse,
    UserRef.typeName,
)

export const getUserApi = createUnaryApi(
    UserServiceClient,
    'get',
    (u) => expandUserView(u.userView, u.expanded),
    UserRef.typeName,
)

export const useSetUserRolesApi = createMutationApi(
    UserServiceClient,
    'setUserRoles',
    (resp): UserValue => expandUserView(resp.userView, resp.expanded),
    UserRef.typeName,
)

export const updateUserApi = createMutationApi(
    UserServiceClient,
    'update',
    (u) => expandUserView(u.userView, u.expanded),
    UserRef.typeName,
)

export const setDelegatedUserApi = createMutationApi(
    UserServiceClient,
    'setDelegatedUser',
    (u) => expandUserView(u.userView, u.expanded),
    UserRef.typeName,
)

export const countAppUsersWithoutManager = createUnaryApi(UserSearchClient, 'countAppUsersWithoutManager')

export const usersWithoutManager = createPagedListApi(
    UserSearchClient,
    'usersWithoutManager',
    transformUserValueArrayResponse,
)

export const usersWithUnspecifiedEmploymentStatus = createPagedListApi(
    UserSearchClient,
    'searchUsersWithUnspecifiedEmploymentStatus',
    transformUserValueArrayResponse,
)

export const searchWithCEL = createPagedListApi(
    UserSearchClient,
    'searchWithCEL',
    transformUserValueArrayResponse,
)

export const getEmploymentStatusSearchTermsApi = createUnaryApi(UserSearchClient, 'getEmploymentStatusSearchTerms')
export const getDepartmentSearchTermsApi = createUnaryApi(UserSearchClient, 'getDepartmentSearchTerms')
export const getJobTitleSearchTermsApi = createUnaryApi(UserSearchClient, 'getJobTitleSearchTerms')

const multiGetUserOpts: MultiGetOpts<UserRef, UserServiceGetUsersByIDsRequest, UserServiceGetUsersByIDsResponse, UserValue> = {
    buildRequest: (refs: UserRef[]) => UserServiceGetUsersByIDsRequest.create({
        ids: refs.map((ref) => ref.id),
        expandMask: { paths: ['*'] },
    }),
    transformResponse: (res: UserServiceGetUsersByIDsResponse) => {
        return res.items.map((view): UserValue => expandUserView(view, res.expanded))
    },
    refExtractor: (item: UserValue) => {
        return { id: item.id }
    },
    maxBatchSize: 32,
    tag: UserRef.typeName,
    enableWebsocketRefresh: true,
}

export const getUserMultiApi = createMultiGetApi(
    UserServiceClient,
    'getByIDs',
    multiGetUserOpts,
)

export const getExpiringUserDelegationBindingApi = createUnaryApi(
    UserServiceClient,
    'getExpiringUserDelegationBinding',
    undefined,
    UserRef.typeName,
)

export const setExpiringUserDelegationBindingSelfApi = createMutationApi(
    UserServiceClient,
    'setExpiringUserDelegationBindingSelf',
    undefined,
    UserRef.typeName,
)

export const setExpiringUserDelegationBindingByAdminApi = createMutationApi(
    UserServiceClient,
    'setExpiringUserDelegationBindingByAdmin',
    undefined,
    UserRef.typeName,
)

export const getUserProfileTypesApi = createUnaryApi(
    UserServiceClient,
    'getUserProfileTypes',
    undefined,
    UserRef.typeName,
)

export const searchUserAttributesWithProfileTypeSourceApi = createUnaryApi(
    UserSearchClient,
    'searchUserAttributesWithProfileTypeSource',
)

export const previewUserProfileWithProfileTypesApi = createMutationApi(
    UserServiceClient,
    'previewUserProfileWithProfileTypes',
)
